module.exports = __webpack_public_path__ + "static/media/snowboard.a7d06046.svg";